const colors = {
  TRANSPARENT: '#FFFFFF00',
  GREY: '#767676',
  BG_COLOR: '#F2F4FA',
  LIGHT_GREY: '#E0E1E2',
  LIGHT_GREY_2: '#A0A0A0',
  RC_ACTION: '#185D72',
  RC_AQUA: '#15CEC4',
  RC_BLACK: '#0A1514',
  RC_GREEN: '#2B6317',
  RC_ORANGE: '#FFB11A',
  RC_RED: '#B20107',
  RC_ROYAL: '#002391',
  RC_TURQUOISE: '#C4E8E7',
  RC_BLUE: '#1E83D3',
  RC_GREEN_JADE: '#378B87',
  RC_LIGHT_RED: '#FE1A20',
  LIGHT_BLUE: '#187bc1',
};

export default colors;
